import { render, staticRenderFns } from "./points-extract.vue?vue&type=template&id=189548fa&"
import script from "./points-extract.vue?vue&type=script&lang=js&"
export * from "./points-extract.vue?vue&type=script&lang=js&"
import style0 from "./points-extract.vue?vue&type=style&index=0&id=189548fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports